import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./ProductionLineOfCreditSection.css";
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";
import { CashFlowIncomeType, LoanType } from "shared/Enums";

interface ProductionLineOfCreditSectionProps {
  loanDetails: LoanApplication
}

export default class ProductionLineOfCreditSection extends React.Component<ProductionLineOfCreditSectionProps> {
  render() {
    return (
      <>
        {this.props.loanDetails.loanType === LoanType.ProductionLineOfCredit && this.props.loanDetails.loanProductionLineOfCredit !== undefined && this.props.loanDetails.loanProductionLineOfCredit.cashFlow !== undefined &&
          <>
            <div>
              <h3>Farm Business Plan Details</h3>
              <h5>Introduction</h5>
              <Table bordered striped={false} size="sm">
                <thead style={{ fontSize: 12 }}>
                  <th>Has Current Loan?</th>
                  <th>Current Loan Balance</th>
                  <th>Production Cycle Start</th>
                  <th>Production End Start</th>
                  <th>As Of Date</th>
                  <th>Projected or Actual</th>
                  <th>Submitted Date</th>
                </thead>
                <tbody>
                  <>
                    <tr>
                      <td className="app-info">{this.props.loanDetails.loanProductionLineOfCredit.hasCurrentLoan ? 'Yes' : 'No'}</td>
                      <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.loanProductionLineOfCredit.hasCurrentLoan ? this.props.loanDetails.loanProductionLineOfCredit.currentLoanBalance : 0)}</td>
                      <td className="app-info">{loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.loanProductionLineOfCredit.cashFlow.introductionSection.cycleStart ?? new Date())}</td>
                      <td className="app-info">{loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.loanProductionLineOfCredit.cashFlow.introductionSection.cycleEnd ?? new Date())}</td>
                      <td className="app-info">{loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.loanProductionLineOfCredit.cashFlow.introductionSection.asOfDate ?? new Date())}</td>
                      <td className="app-info">{this.props.loanDetails.loanProductionLineOfCredit.cashFlow.introductionSection.projected ? 'Projected' : 'Actual'}</td>
                      <td className="app-info">{loanApplicationUtility.GetFullYearDateText(new Date())}</td>
                    </tr>
                  </>
                </tbody>
              </Table>

              {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection !== undefined &&
                <>
                  <h5>Income</h5>
                  <div style={{ marginLeft: 10, fontStyle: 'italic', fontWeight: 'bold' }}>
                    {
                      `Grand Total Income: ${loanApplicationUtility.BuildCurrencyAmount((this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalProductionIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalOtherFarmIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalNonFarmIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalCapitalSalesIncome ?? 0))}`
                    }
                  </div>
                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.CropProduction) &&
                    <>
                      <div>Crop Production</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Location</th>
                          <th>Unit of Measure</th>
                          <th>Number of Acres</th>
                          <th>Yield Per Acre</th>
                          <th>Number of Units Produced</th>
                          <th>Ownership %</th>
                          <th>My Share Of Units</th>
                          <th>Units For Farm Use</th>
                          <th>Sales # Units</th>
                          <th>Sales $/Unit</th>
                          <th>Sales Total $</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.CropProduction).map((cp, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{cp.description}</td>
                                  <td className="app-info">{cp.location ?? '--'}</td>
                                  <td className="app-info">{cp.productionIncome?.unitOfMeasure}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(cp.productionIncome?.acres)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(cp.productionIncome?.yield)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount((cp.productionIncome?.acres ?? 0) * (cp.productionIncome?.yield ?? 0))}</td>
                                  <td className="app-info">{`${cp.productionIncome?.percentageOwned}%`}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(cp.productionIncome?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(cp.productionIncome?.amountFarmUse)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(cp.productionSale?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(cp.productionSale?.pricePerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(cp.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryRaised) &&
                    <>
                      <div>Livestock & Poultry - Raised</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Type</th>
                          <th>Location</th>
                          <th>Number of Units Selling</th>
                          <th>Sales Weight</th>
                          <th>Total Sales Weight</th>
                          <th>Ownership %</th>
                          <th>Sales $/Unit</th>
                          <th>Sales Total $</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockAndPoultryRaised).map((lp, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{lp.description}</td>
                                  <td className="app-info">{lp.type}</td>
                                  <td className="app-info">{lp.location ?? '--'}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionSale?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionSale?.weightPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount((lp.productionSale?.weightPerUnit ?? 0) * (lp.productionSale?.numberOfUnits ?? 0))}</td>
                                  <td className="app-info">{`${lp.productionSale?.percentageOwned}%`}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.pricePerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryPurchaseSale) &&
                    <>
                      <div>Livestock & Poultry - Purchased & Sold</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Type</th>
                          <th>Location</th>
                          <th>Production # Units</th>
                          <th>Purchase Weight</th>
                          <th>Purchase $/Unit</th>
                          <th>Purchase Total</th>
                          <th>Sales # Units</th>
                          <th>Sales Weight</th>
                          <th>Sales $/Unit</th>
                          <th>Sales Total $</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockAndPoultryPurchaseSale).map((lp, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{lp.description}</td>
                                  <td className="app-info">{lp.type}</td>
                                  <td className="app-info">{lp.location ?? '--'}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionPurchase?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionPurchase?.purchaseWeightPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionPurchase?.purchaseDollarPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionPurchase?.purchaseTotalAmount)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionSale?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionSale?.weightPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.pricePerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.DairyLivestock) &&
                    <>
                      <div>Dairy Market Livestock - Purchased & Sold</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Breed</th>
                          <th>Location</th>
                          <th>Production # Units</th>
                          <th>Purchase Weight</th>
                          <th>Purchase $/Unit</th>
                          <th>Purchase Total</th>
                          <th>Expected Death Loss</th>
                          <th>Sales # Units</th>
                          <th>Sales Weight</th>
                          <th>Sales $/Unit</th>
                          <th>Sales Total $</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.DairyLivestock).map((dl, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{dl.description}</td>
                                  <td className="app-info">{dl.type}</td>
                                  <td className="app-info">{dl.location ?? '--'}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(dl.productionPurchase?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(dl.productionPurchase?.purchaseWeightPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(dl.productionPurchase?.purchaseDollarPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(dl.productionPurchase?.purchaseTotalAmount)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(dl.productionSale?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(dl.productionSale?.weightPerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(dl.productionSale?.pricePerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(dl.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.MilkProduction) &&
                    <>
                      <div>Milk Production</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Breed</th>
                          <th>Location</th>
                          <th># Head</th>
                          <th>Production Lbs Per Head/Per Year</th>
                          <th>Total Production</th>
                          <th>Market Price Per Unit</th>
                          <th>Total Sales</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.MilkProduction).map((ms, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{ms.description}</td>
                                  <td className="app-info">{ms.type}</td>
                                  <td className="app-info">{ms.location}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(ms.productionSale?.numberOfHead)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(ms.productionSale?.productionPerHead)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(ms.productionSale?.totalProduction)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(ms.productionSale?.marketPrice)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(ms.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeTypes?.includes(CashFlowIncomeType.LivestockProduct) &&
                    <>
                      <div>Farm Product Sales</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Description</th>
                          <th>Commodity Type</th>
                          <th>Commodity Measure</th>
                          <th>Number of Units Selling</th>
                          <th>Price Per Unit</th>
                          <th>Total Sales</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockProduct).map((lp, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{lp.description}</td>
                                  <td className="app-info">{lp.productionSale?.commodityProduced}</td>
                                  <td className="app-info">{lp.productionSale?.commodityMeasure}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildAmount(lp.productionSale?.numberOfUnits)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.pricePerUnit)}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(lp.productionSale?.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.otherIncomeTypes?.includes(CashFlowIncomeType.OtherFarmIncome) &&
                    <>
                      <div>Other Farm Income</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Income Type</th>
                          <th>Description</th>
                          <th>Amount</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.otherFarmIncome?.map((ofi, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{loanApplicationUtility.GetCashFlowOtherFarmIncomeTypeText(ofi.otherIncomeType ?? 1)}</td>
                                  <td className="app-info">{ofi.description}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(ofi.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }

                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.otherIncomeTypes?.includes(CashFlowIncomeType.NonFarmIncome) &&
                    <>
                      <div>Non-Farm Income</div>
                      <Table bordered striped={false} size="sm">
                        <thead style={{ fontSize: 12 }}>
                          <th>Income Type</th>
                          <th>Description</th>
                          <th>Amount</th>
                        </thead>
                        <tbody>
                          {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.incomeSection.nonFarmIncome?.map((nfi, i) => {
                            return (
                              <>
                                <tr>
                                  <td className="app-info">{loanApplicationUtility.GetCashFlowNonFarmIncomeTypeText(nfi.nonFarmIncomeType ?? 1)}</td>
                                  <td className="app-info">{nfi.description}</td>
                                  <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(nfi.totalAmount)}</td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </>
                  }
                </>
              }

              {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.expensesSection !== undefined &&
                <>
                  <h5>Expenses</h5>
                  <div style={{ marginLeft: 10, fontStyle: 'italic', fontWeight: 'bold' }}>
                    {
                      `Grand Total Expenses: ${loanApplicationUtility.BuildCurrencyAmount((this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.expensesSection.totalExpenseAmount ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.otherExpenseSection.totalOtherExpenseAmount ?? 0))}`
                    }
                  </div>
                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.expensesSection.expenses != undefined && this.props.loanDetails.loanProductionLineOfCredit.cashFlow.expensesSection.expenses.length > 0
                    ?
                    <Table bordered striped={false} size="sm">
                      <thead style={{ fontSize: 12 }}>
                        <th>Description</th>
                        <th>Amount</th>
                      </thead>
                      <tbody>
                        {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.expensesSection.expenses.map((e, i) => {
                          return (
                            <tr>
                              <td className="app-info">{loanApplicationUtility.GetCashFlowExpenseTypeText(e.expenseType ?? 1)}</td>
                              <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(e.totalAmount)}</td>
                            </tr>
                          )
                        })
                        }
                      </tbody>
                    </Table>
                    :
                    <div> No expenses</div>
                  }
                </>
              }

              {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.otherExpenseSection !== undefined &&
                <>
                  <h5>Non-Operating</h5>
                  {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.otherExpenseSection.otherExpenseItems != undefined && this.props.loanDetails.loanProductionLineOfCredit.cashFlow.otherExpenseSection.otherExpenseItems.length > 0
                    ?
                    <Table bordered striped={false} size="sm">
                      <thead style={{ fontSize: 12 }}>
                        <th>Other Expense Type</th>
                        <th>Description</th>
                        <th>Amount</th>
                      </thead>
                      <tbody>
                        {this.props.loanDetails.loanProductionLineOfCredit.cashFlow.otherExpenseSection.otherExpenseItems.map((oei, i) => {
                          return (
                            <tr>
                              <td className="app-info">{loanApplicationUtility.GetCashFlowOtherExpenseTypeText(oei.otherExpenseType ?? 1)}</td>
                              <td className="app-info">{oei.description}</td>
                              <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(oei.totalAmount)}</td>
                            </tr>
                          )
                        })
                        }
                      </tbody>
                    </Table>
                    :
                    <div> No "Other Expenses" Added</div>
                  }
                </>
              }

              <h5>
                <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                  {
                    `Net Income Available For Debt Service: ${loanApplicationUtility.BuildCurrencyAmount(
                      (
                        (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalProductionIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalOtherFarmIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalNonFarmIncome ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.incomeSection.totalCapitalSalesIncome ?? 0)
                      ) -
                      (
                        (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.expensesSection.totalExpenseAmount ?? 0)
                        + (this.props.loanDetails.loanProductionLineOfCredit?.cashFlow.otherExpenseSection.totalOtherExpenseAmount ?? 0)
                      )
                    )}`
                  }
                </span>
              </h5>
            </div>
          </>
        }
      </>
    );
  }
}